<template>
	<form v-on:submit.prevent="saveApplicant">
		<fieldset>
			<legend>
				<i class="fad fa-user-edit"></i> Tier 2 Application
			</legend>
			<p>
				{{nameFirst}} please fill out the questions below.  You will not be able to edit this form after submission, so please have all of your materials ready.
			</p>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-photo-video"></i> Video Essay Submission
			</legend>
			<p>Record and share a one-minute video response to the below prompt. &mdash;  <strong>1 Minute Total</strong></p>
			<h3>
				What is your plan to use this scholarship and mentoring opportunity to live in NYC for one year?
			</h3>
			<div class="label-field">
				<label for="essay-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 150mb)</span>
				</label>
				<div v-if="videoEssay.uploading">
					<span v-if="videoEssay.progress">{{videoEssay.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoEssay.file"><input data-model="videoEssay" data-attr="file" data-type="video" id="essay-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoEssay.file.name}}</strong></div>
				</div>

				<div v-if="videoEssay.file">
					Current Upload: <strong>videoEssay.file</strong>
				</div>


				<div class="or">&mdash;OR&mdash;</div>
				<label for="essay-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input id="essay-url" class="file-url" type="url" v-model="videoEssay.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-star"></i> Dance Piece Submission 
			</legend>
			<p>
				Work samples may be excerpts from longer dances either choreographed or self-choreographed and filmed in performance or in studio. 
			</p>
			<p>
				Solo work is preferred. If the piece is not a solo, identify which dancer is you. Please notate this in the Description. (eg. I am wearing the blue leotard or, I am the dancer furthest stage right at the beginning of the video.)
			</p>
			<p>
				These work samples should be filmed recently and should not be more than one year old.
			</p>
			<p>
				You do have the option to use the same dance pieces uploaded to Tier 1 of your application if you so choose.
			</p>
			<h3>
				Upload up to THREE contrasting dance pieces not to exceed six minutes in total. Please edit these pieces together into one file or YouTube Video. &mdash; <strong>6 Minutes Total</strong>
			</h3>
			<div class="label-field">
				<label for="dance2-file">
					<i class="fad fa-file-upload"></i> Upload a video <span>(.mp4/.mov, &lt; 840mb)</span>
				</label>
				<div v-if="videoDance2.uploading">
					<span v-if="videoDance2.progress">{{videoDance2.progress}}%</span> uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!videoDance2.file"><input data-model="videoDance2" data-attr="file" data-type="video" id="dance2-file" type="file" accept="video/*" v-on:change="fileAttachment"  /></div><div v-else> &nbsp; <strong>{{videoDance2.file.name}}</strong></div>
				</div>

				<div v-if="videoDance2.file">
					Current Upload: <strong>videoDance2.file</strong>
				</div>

				<div class="or">&mdash;OR&mdash;</div>
				<label for="dance2-url">
					<i class="fad fa-link"></i> Share YouTube/Vimeo Link<br />
				</label>
				<input data-model="videoDance2" data-type="video" id="dance2-url" class="file-url" type="url" v-model="videoDance2.url" placeholder="https://youtu.be/uNiQuE_uRl_HeRe" >
				<p><strong>*Disclaimer: To ensure your application is viewed in full by Adjudicators, please adhere to time requirements and limitations.</strong></p>
			</div>
			<div class="or">&mdash;AND&mdash;</div>
			<div class="label-field">
				<label for="dance2-file">
					<i class="fad fa-comment-alt-lines"></i> Description of Dance Piece
				</label>
				<p>Please notate information helpful to the adjudicators in viewing your work sample. (Name of the choreographer, if it is self-choreographed, and please identify yourself in group work)</p>
				<textarea id="dance2-description" v-model="videoDance2.description" rows="6"></textarea>
			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-chart-pie"></i> Budget Planning Form
			</legend>
			<p>
				Please complete the budget form found <a href="https://cdn.offthelane.org/wp-content/uploads/2021/08/22202942/Ann_Reinking_Scholarship_Budget_Planner.xlsx" target="_blank">HERE</a>! This form helps us understand how you intend to use Scholarship monies to support your year in NYC.
			</p>

			<div class="label-field">
				<label for="budget">
					<i class="fad fa-file-pdf"></i> Budget <span>(.pdf &lt; 6mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.budget"><input data-model="materials" data-attr="budget" data-type="document" id="budget-file" type="file" accept="application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.budget.name}}</strong></div>
					<!-- .xlsx,.xls,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, -->
				</div>

				<div v-if="materials.budget">
					Current Upload: <strong>{{materials.budget}}</strong>
				</div>

			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-hand-holding-usd"></i> 2020 Tax Return
			</legend>
			<p>
				*Please redact Social Security Number.
			</p>
			<div class="label-field">
				<label for="tax">
					<i class="fad fa-file-pdf"></i> Tax <span>(.pdf &lt; 20mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.tax"><input data-model="materials" data-attr="tax" data-type="document" id="tax-file" type="file" accept="application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.tax.name}}</strong></div>
				</div>

				<div v-if="materials.tax">
					Current Upload: <strong>{{materials.tax}}</strong>
				</div>

			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-file-invoice-dollar"></i> Last Two Bank Statements
			</legend>
			<p>
				*Please redact account number.
			</p>
			<div class="label-field">
				<label for="bank1">
					<i class="fad fa-file-pdf"></i> Bank #1 <span>(.pdf &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.bank1"><input data-model="materials" data-attr="bank1" data-type="document" id="bank1-file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.bank1.name}}</strong></div>
				</div>

				<div v-if="materials.bank1">
					Current Upload: <strong>{{materials.bank1}}</strong>
				</div>

			</div>
			<div class="label-field">
				<label for="bank2">
					<i class="fad fa-file-pdf"></i> Bank #2 <span>(.pdf &lt; 10mb)</span>
				</label>
				<div v-if="materials.uploading">
					uploading <i class="fad fa-spinner-third fa-spin fa-lg"></i>
				</div>
				<div v-else>
					<div v-if="!materials.bank2"><input data-model="materials" data-attr="bank2" data-type="document" id="bank2-file" type="file" accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,application/pdf" v-on:change="fileAttachment" required  /></div><div v-else> &nbsp; <strong>{{materials.bank2.name}}</strong></div>
				</div>

				<div v-if="materials.bank2">
					Current Upload: <strong>{{materials.bank2}}</strong>
				</div>

			</div>
		</fieldset>
		<fieldset>
			<legend>
				<i class="fad fa-comment-alt-smile"></i> Zoom Interview
			</legend>
			<p>
				Individual Zoom interviews will be scheduled with Finalists during the period September 30 – October 7th.
			</p>
			<p>
				The interview will be led by Bonnie Oda Homsey, Chair of the Adjudication Committee, with three select Adjudicators.
			</p>
			<p>
				The interview will last approximately 15 minutes and will offer a wonderful opportunity to get to know you! 
			</p>
			<p>
				<strong>Note: Please download this form, fill out and save as a PDF before uploading.</strong>
			</p>
		</fieldset>
		<fieldset>
			<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
			<div v-else class="label-field">
				<button>
					<span>SUBMIT</span> <i class="fad fa-angle-right fa-fw"></i>
				</button>
			</div>
		</fieldset>
	</form>
</template>
<script>
const alphabet = '0123456789ABCDEFGHIJKLMNOPQRSTUVZ'
const nanoidAlt = customAlphabet(alphabet, 12)
import { projectStorage } from '../firebase/config'
import { customAlphabet } from 'nanoid'
export default {
	emits: ['save-applicant'],
	props: {
		isLoading: {
			type: Boolean
		},
		isPrivate: {
			type: Boolean
		},
		crud: {
			type: String,
			required: true
		},
		applicant: {
			type: Object,
			required: true
		}
	},
	data() {
		return {
			appId: this.applicant.appId || null,
			altId: this.applicant.altId || nanoidAlt(),
			nameFirst: this.applicant.nameFirst || null,
			nameLast: this.applicant.nameLast || null,
			pronouns: this.applicant.pronouns || null,
			address: {
				line1: this.applicant.address.line1 || null,
				city: this.applicant.address.city || null,
				state: this.applicant.address.state || null,
				zip: this.applicant.address.zip || null
			},
			email: this.applicant.email || null,
			phone: this.applicant.phone || null,
			citizen: this.applicant.citizen || null,
			dob: this.applicant.dob || null,
			school: this.applicant.school || null,
			income: this.applicant.income || null,
			otherInc: {
				support: this.applicant.otherInc.support || null,
				savings: this.applicant.otherInc.savings || null,
				loans: this.applicant.otherInc.loans || null,
				existing: this.applicant.otherInc.existing || null,
				investments: this.applicant.otherInc.investments || null,
				other: this.applicant.otherInc.other || null,
				detail: this.applicant.otherInc.detail || null
			},
			otherDetails: this.applicant.otherInc.detail || null,
			videoGoal: {
				file: this.applicant.videoGoal.file || null,
				url: this.applicant.videoGoal.url || null,
				uploading: false,
				progress: null
			},
			videoDance: {
				file: this.applicant.videoDance.file || null,
				url: this.applicant.videoDance.url || null,
				description: this.applicant.videoDance.description || null,
				uploading: false,
				progress: null
			},
			materials: {
				headshot: this.applicant.materials.headshot || null,
				resume: this.applicant.materials.resume || null,
				letter: this.applicant.materials.letter || null,
				tax: this.applicant.materials.tax || null,
				bank1: this.applicant.materials.bank1 || null,
				bank2: this.applicant.materials.bank2 || null,
				budget: this.applicant.materials.budget || null,
				uploading: false,
				progress: null
			},
			videoEssay: {
				file: this.applicant.videoEssay !== undefined ? this.applicant.videoEssay.file : null,
				url: this.applicant.videoEssay !== undefined ? this.applicant.videoEssay.url : null,
				uploading: false,
				progress: null
			},
			videoDance2: {
				file: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.file : null,
				url: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.url : null,
				description: this.applicant.videoDance2 !== undefined ? this.applicant.videoDance2.description : null,
				uploading: false,
				progress: null
			},
			consent: this.applicant.consent || null,
			confirm: this.applicant.confirm || null,
			status: this.applicant.status || null,
			notes: this.applicant.notes || null,
			user: this.applicant.user || null,
			dateCreated: this.applicant.dateCreated || null,
			validated: true
		}
	},
	watch: {

	},
	methods: {
		citizenship(){
			alert('You must be eligible to live and work in the US in order to receive this grant of money. Should your status change, don\'t hesitate to reapply.')
		},
		otherDetail(){
			this.otherDetails = !this.otherDetails;
		},
		fileAttachment(e){
			let dataModel = e.target.getAttribute('data-model')
			let dataAttr = e.target.getAttribute('data-attr')
			let dataType = e.target.getAttribute('data-type')
			let fileUpload = e.target.files[0]
			let videoTypes = ['video/quicktime','video/mp4','video/wav','video/mp4']
			let fileTypes = ['image/png','image/jpeg','application/pdf','application/vnd.openxmlformats-officedocument.spreadsheetml.sheet']

			if(dataModel && fileUpload){

				this.[dataModel].uploading = true
				this.[dataModel].[dataAttr] = fileUpload
				let folder = 'documents'

				if(dataAttr === 'file'){
					folder = 'videos'
				}

				var folder_path = `applicants/${this.altId}/${folder}/${fileUpload.name}`
				const storageRef = projectStorage.ref(folder_path)
				let uploadTask = null

				if(dataType === 'video'){
					if(fileUpload.size < 1230000000 && videoTypes.includes(fileUpload.type)){
						try {
							uploadTask = storageRef.put(fileUpload)
						} catch (error) {
							alert(error)
						} finally {
							//this.[dataModel].uploading = false
						}
					} else {
						this.[dataModel].[dataAttr] = null
						alert('File is too large or is NOT supported :(')
						this.[dataModel].uploading = false
					}
				} else if(dataType === 'document'){
					if(fileUpload.size < 188743680 && fileTypes.includes(fileUpload.type)){
						try {
							uploadTask = storageRef.put(fileUpload)
						} catch (error) {
							alert(error)
						} finally {
							//this.[dataModel].uploading = false
						}
					} else {
						alert('File is too large or is NOT supported :(')
						this.[dataModel].uploading = false
					}
				} else {
					alert('an error has occured :(')
				}

				uploadTask.on('state_changed', 
					(snapshot) => {
						this.[dataModel].progress = parseFloat((snapshot.bytesTransferred / snapshot.totalBytes) * 100).toFixed(2)
						// switch (snapshot.state) {
						// 	case projectStorage.TaskState.PAUSED: // or 'paused'
						// 		console.log('Upload is paused');
						// 		break;
						// 	case projectStorage.TaskState.RUNNING: // or 'running'
						// 		console.log('Upload is running');
						// 		break;
						// }
					}, 
					(error) => {
						alert( error )
					}, 
					() => {
						//uploadTask.snapshot.ref.getDownloadURL().then((downloadURL) => {
						//	console.log('File available at', downloadURL);
							this.[dataModel].uploading = false
						//});
					}
				);


			}
		},
		saveApplicant(){

			let addressObj = {
				line1: this.address.line1,
				line2: this.address.line2,
				city: this.address.city,
				state: this.address.state,
				zip: this.address.zip
			}

				addressObj = Object.keys(addressObj)
				.filter((k) => addressObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: addressObj[k] }), {})

			var video_goal_file_name = null

			if(this.videoGoal.file){
				video_goal_file_name = this.videoGoal.file.name || this.videoGoal.file
			}

			let videoGoalObj = {
				file: video_goal_file_name,
				url: this.videoGoal.url || null,
			}

				videoGoalObj = Object.keys(videoGoalObj)
				.filter((k) => videoGoalObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoGoalObj[k] }), {})



			var video_dance_file_name = null

			if(this.videoDance.file){
				video_dance_file_name = this.videoDance.file.name || this.videoDance.file
			}

			let videoDanceObj = {
				file:  video_dance_file_name,
				url: this.videoDance.url || null,
				description: this.videoDance.description || null
			}

				videoDanceObj = Object.keys(videoDanceObj)
				.filter((k) => videoDanceObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoDanceObj[k] }), {})

			let materialsObj = {
				headshot: this.materials.headshot.name || this.materials.headshot,
				resume: this.materials.resume.name || this.materials.resume,
				letter: this.materials.letter.name|| this.materials.letter,
				tax: this.materials.tax.name|| this.materials.tax,
				bank1: this.materials.bank1.name|| this.materials.bank1,
				bank2: this.materials.bank2.name|| this.materials.bank2,
				budget: this.materials.budget.name|| this.materials.budget
			}

				materialsObj = Object.keys(materialsObj)
				.filter((k) => materialsObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: materialsObj[k] }), {})


			var video_essay_file_name = null

			if(this.videoEssay.file){
				video_essay_file_name = this.videoEssay.file.name || this.videoEssay.file
			}

			let videoEssayObj = {
				file: video_essay_file_name,
				url: this.videoEssay.url || null,
			}

				videoEssayObj = Object.keys(videoEssayObj)
				.filter((k) => videoEssayObj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoEssayObj[k] }), {})




			var video_dance2_file_name = null

			if(this.videoDance2.file){
				video_dance2_file_name = this.videoDance2.file.name || this.videoDance2.file
			}

			let videoDance2Obj = {
				file: video_dance2_file_name,
				url: this.videoDance2.url || null,
				description: this.videoDance2.description || null
			}

				videoDance2Obj = Object.keys(videoDance2Obj)
				.filter((k) => videoDance2Obj[k] != null)
				.reduce((a, k) => ({ ...a, [k]: videoDance2Obj[k] }), {})




			let otherInc = {
				support: this.otherInc.support,
				savings: this.otherInc.savings,
				existing: this.otherInc.existing,
				investments: this.otherInc.investments,
				other: this.otherInc.other,
				detail: this.otherInc.detail
			}

				otherInc = Object.keys(otherInc)
				.filter((k) => otherInc[k] != null)
				.reduce((a, k) => ({ ...a, [k]: otherInc[k] }), {})



			let applicantData = {
				address: addressObj,
				altId: this.altId,
				appId: this.appId,
				confirm: this.confirm,
				consent: this.consent,
				citizen: JSON.parse(this.citizen),
				dateCreated: this.dateCreated,
				dob: this.dob,
				email: this.email,
				income: this.income,
				materials: materialsObj,
				nameFirst: this.nameFirst,
				nameLast: this.nameLast,
				notes: this.notes,
				otherInc: this.otherInc,
				pronouns: this.pronouns,
				phone: this.phone,
				school: this.school,
				status: this.status,
				user: this.user,
				videoGoal: videoGoalObj,
				videoDance: videoDanceObj,
				videoEssay: videoEssayObj,
				videoDance2: videoDance2Obj
			}

				applicantData = Object.keys(applicantData)
				.filter((k) => applicantData[k] != null)
				.reduce((a, k) => ({ ...a, [k]: applicantData[k] }), {});

			// console.log('applicant data...')
			// console.log(applicantData)
			// console.log(videoGoalObj)
			// console.log('--')

			this.$emit('save-applicant',applicantData)
		}
	},
}
</script>
<style scoped>
dt {
	float: left;
	margin-right: 1ch;
}

.warning {
	color: #ff0000;
}

form {
	max-width: 480px;
}
</style>